import { sentryCreateBrowserRouter } from '@/instrument.ts';
import { RootErrorBoundary } from '@/components/RootErrorBoundary.tsx';
import { Layout } from '@/components/Layout/Layout.tsx';
import { ClientRoute, ClientsRoute, HomeRoute, IOSTenantsRoute } from '@/routeComponents.tsx';

export const router = sentryCreateBrowserRouter([
  {
    Component: Layout,
    ErrorBoundary: RootErrorBoundary,
    children: [
      {
        index: true,
        Component: HomeRoute,
      },
      {
        path: 'app-configurations',
        children: [
          {
            index: true,
            Component: IOSTenantsRoute,
          },
        ],
      },
      {
        path: 'clients',
        children: [
          {
            index: true,
            Component: ClientsRoute,
          },
          {
            path: ':clientId',
            Component: ClientRoute,
          },
        ],
      },
    ],
  },
]);
